import { navigationItems } from "../../data/navigation/navigation";
import type { Locale } from "../../types/app";
import { NavIcon } from "./NavIcon";

const primaryHrefs = ["#/", "#/athkar", "#/favorites", "#/quran", "#/prayer", "#/qibla", "#/moon"] as const;

export function MobileBottomNav({ route, locale }: { readonly route: string; readonly locale: Locale }) {
  const items = navigationItems.filter((item) => primaryHrefs.includes(item.href as (typeof primaryHrefs)[number]));

  return (
    <nav className="bottom-nav" aria-label={locale === "ar" ? "التنقل السريع" : "Quick navigation"}>
      <div className="bottom-nav__inner">
        {items.map((item) => {
          const active = route === item.href.replace("#", "") || (item.href === "#/" && route === "/");
          return (
            <a key={item.href} href={item.href} className={active ? "active" : ""} aria-current={active ? "page" : undefined}>
              <NavIcon name={item.icon} />
              <span>{locale === "ar" ? item.labelAr : item.labelEn}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
}
